<template>

</template>

<script>
import CryptoJS from "crypto-js";
import globalStore from "@/variables";

export default {
    name: "RegisterRedirect.vue",
    mounted() {
        let encryptedData = CryptoJS.AES.encrypt(JSON.stringify({source: 'simon'}), globalStore.data.keycloakRegisterKey);
        let redirectToken = window.btoa(encryptedData.toString());
        window.location.href = globalStore.data.keycloakRegisterUrl + '?token=' + redirectToken
    }
}
</script>

<style scoped>

</style>